import React from "react"
import { motion } from 'framer-motion'

const FilterLoader = () => {
    return <motion.div className="w-full h-[80vh] flex flex-col overflow-y-scroll gap-5 px-2 py-2">
        <p className="flex flex-row justify-start gap-5 font-bold text-primeColor text-xl"><span className="animate-pulse w-5 h-5 bg-primeColor/20 drop-shadow-lg rounded"></span><span className="animate-pulse w-32 h-5 bg-primeColor/20 drop-shadow-lg rounded"></span></p>
        <motion.div className={`w-full h-full flex flex-col gap-2`}>
            <p className="font-bold text-xl"><span className="animate-pulse w-20 h-2 bg-primeColor/20 drop-shadow-lg rounded"></span></p>
            <motion.div className="w-full h-full flex flex-col gap-2">
                {[1, 2, 3].map((c, i) => {
                    return <motion.div key={i} className="w-full flex flex-row">
                        <p className="text-md text-black font-semibold ml-2"><span className="animate-pulse w-32 h-4 bg-primeColor/20 drop-shadow-lg rounded"></span></p>
                    </motion.div>
                })}
            </motion.div>
        </motion.div>
        <motion.div className={`w-full h-full flex flex-col gap-2`}>
            <p className="font-bold text-xl"><span className="animate-pulse w-20 h-2 bg-primeColor/20 drop-shadow-lg rounded"></span></p>
            <motion.div className="w-full h-full flex flex-col gap-2">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((c, i) => {
                    return <motion.div key={i} className="w-full flex flex-row">
                        <p className="text-md text-black font-semibold ml-2"><span className="animate-pulse w-32 h-4 bg-primeColor/20 drop-shadow-lg rounded"></span></p>
                    </motion.div>
                })}
            </motion.div>
        </motion.div>
        <motion.div className={`w-full h-full flex flex-col gap-2`}>
            <p className="font-bold text-xl"><span className="animate-pulse w-20 h-2 bg-primeColor/20 drop-shadow-lg rounded"></span></p>
            <motion.div className="w-full h-full flex flex-col gap-2">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((c, i) => {
                    return <motion.div key={i} className="w-full flex flex-row">
                        <p className="text-md text-black font-semibold ml-2"><span className="animate-pulse w-32 h-4 bg-primeColor/20 drop-shadow-lg rounded"></span></p>
                    </motion.div>
                })}
            </motion.div>
        </motion.div>
    </motion.div>
}


export default FilterLoader